import Vue from 'vue'
import VueRouter from 'vue-router'
const Login = resolve =>{
    require.ensure(['./theme/default/Login.vue'], ()=>{
        resolve(require('./theme/default/Login.vue'))
    })
}
const LoginForm = resolve =>{
    require.ensure(['./theme/default/LoginForm.vue'],()=>{
        resolve(require('./theme/default/LoginForm.vue'))
    })
}
const RegisterForm = resolve => {
    require.ensure(['./theme/default/RegisterForm.vue'], ()=>{
        resolve(require('./theme/default/RegisterForm.vue'))
    })
}
const ForgotPassword = resolve =>{
    require.ensure(['./theme/default/ForgotPassword.vue'], ()=>{
        resolve(require('./theme/default/ForgotPassword.vue'))
    })
}
const ForgotUsername = resolve =>{
    require.ensure(['./theme/default/ForgotUsername.vue'], ()=>{
        resolve(require('./theme/default/ForgotUsername.vue'))
                 })
}
const PasswordResetForm = resolve =>{
    require.ensure(['./theme/default/PasswordResetForm.vue'], ()=>{
        resolve(require('./theme/default/PasswordResetForm.vue'))
    })
}
import DashboardLayout from './theme/default/auth/DashboardLayout.vue'

const Radio = resolve => {
    require.ensure(['./theme/default/auth/Radios.vue'], () => {
        resolve(require('./theme/default/auth/Radios.vue'))
    })
}

const Profile = resolve => {
    require.ensure(['./theme/default/auth/Profile.vue'], ()=>{
        resolve(require('./theme/default/auth/Profile.vue'))
    })
}


const QuickStart = resolve => {
    require.ensure(['./theme/default/auth/QuickStart.vue'], ()=>{
        resolve(require('./theme/default/auth/QuickStart.vue'))
    })
}

const Users = resolve=>{
    require.ensure(['./theme/default/admin/Users.vue'],()=>{
        resolve(require('./theme/default/admin/Users.vue'))
    })
}

const Layout = resolve => {
    require.ensure(['./theme/default/admin/Layout.vue'], ()=>{
        resolve(require('./theme/default/admin/Layout.vue'));
    });
}

const AdminRadio = resolve => {
    require.ensure(['./theme/default/admin/Radios.vue'], () => {
        resolve(require('./theme/default/admin/Radios.vue'))
    })
}

const AdminProfile = resolve => {
    require.ensure(['./theme/default/admin/Profile.vue'], ()=>{
        resolve(require('./theme/default/admin/Profile.vue'))
    })
}


const AdminQuickStart = resolve => {
    require.ensure(['./theme/default/admin/QuickStart.vue'], ()=>{
        resolve(require('./theme/default/admin/QuickStart.vue'))
    })
}

const ApiLog = resolve => {
    require.ensure(['./theme/default/admin/ApiLog.vue'], ()=>{
        resolve(require('./theme/default/admin/ApiLog.vue'))
    })
}

const Message = resolve => {
    require.ensure(['./theme/default/admin/Messages.vue'], ()=>{
        resolve(require('./theme/default/admin/Messages.vue'))
    })
}

const UserMessage = resolve =>{
    require.ensure(['./theme/default/auth/Messages.vue'], ()=>{
        resolve(require('./theme/default/auth/Messages.vue'))
    })
}

const Playlist = resolve => {
    require.ensure(['./theme/default/auth/Playlist.vue'], ()=>{
        resolve(require('./theme/default/auth/Playlist.vue'))
    })
}

const AdminPlaylist = resolve => {
    require.ensure(['./theme/default/admin/Playlist.vue'], ()=>{
        resolve(require('./theme/default/admin/Playlist.vue'))
    })
}

const ScheduleNew = resolve => {
    require.ensure(['./theme/default/auth/ScheduleNew.vue'], ()=>{
        resolve(require('./theme/default/auth/ScheduleNew.vue'))
    })
}

const ScheduleAuth = resolve => {
    require.ensure(['./theme/default/auth/Schedule.vue'], ()=>{
        resolve(require('./theme/default/auth/Schedule.vue'))
    })
}


const Schedule = resolve => {
    require.ensure(['./theme/default/admin/Schedule.vue'], ()=>{
        resolve(require('./theme/default/admin/Schedule.vue'))
    })
}

import store from './store'

Vue.use(VueRouter)

const routes = [
    {
        path:'/', 
        component: Login,
        beforeEnter(to, from, next){
            if(localStorage.getItem('token') != null && store.state.token != null){
                store.state.logoutMdl = true
            }else{
                next()
            }
        },
        children:[
            {path:'', component: LoginForm},
            {path:'/register', component: RegisterForm},
            {path:'/forgot-password', component: ForgotPassword},
            {path:'/forgot-username', component: ForgotUsername},
            {path:'/password/reset/:token', component: PasswordResetForm},
        ]
    },
    {
        path: '/dashboard/radios',
        component: DashboardLayout,
        beforeEnter(to,from,next){
            if(store.state.token){
                next()
            }else{
                next('/')
            }
        },
        children:[
            {path:'', component: Radio},
            {path: '/dashboard/schedule', component: ScheduleNew},
            {path: '/dashboard/schedule/:id', component: ScheduleNew},
            {path: '/dashboard/schedules', component: ScheduleAuth},
            {path: '/dashboard/schedules/:id', component: ScheduleAuth},
            {path:'/dashboard/profile', component: Profile},
            {path:'/dashboard/radios', component: Radio},
            {path:'/dashboard/quick-start', component: QuickStart},
            {path: '/dashboard/messages', component: UserMessage},
            {path: '/dashboard/playlist', component: Playlist},
            // {path: '/dashboard/schedule-new', component: ScheduleNew}
        ]
    },
    {
        path: '/admin/radios',
        component: Layout,
        beforeEnter(to,from,next){
            if(store.state.token){
                next()
            }else{
                next('/')
            }
        },
        children:[
            {path: '', component: AdminRadio},
            {path: '/admin/radios', component: AdminRadio},
            {path: '/admin/radios/:id', component: AdminRadio},
            {path: '/admin/schedules', component: Schedule},
            {path: '/admin/schedules/:id', component: Schedule},
            {path: '/admin/profile', component: AdminProfile},
            {path: '/admin/quick-start', component: AdminQuickStart},
            {path: '/admin/users', component: Users},
            {path: '/admin/users/:id', component: Users},
            {path: '/admin/console', component: ApiLog},
            {path: '/admin/messages', component: Message},
            {path: '/admin/playlist', component: AdminPlaylist}
        ]
    }
    
]

export default new VueRouter({mode:'history', routes})
